// extracted by mini-css-extract-plugin
export var colorSquare = "_r7-0";
export var danger = "_r7-5";
export var lightPink = "_r7-8";
export var neutralBlue = "_r7-7";
export var neutralYellow = "_r7-6";
export var normal = "_r7-1";
export var primary = "_r7-2";
export var primaryLight = "_r7-3";
export var solidBlack = "_r7-g";
export var solidGreen = "_r7-b";
export var solidLightBlue = "_r7-d";
export var solidNavy = "_r7-c";
export var solidOrange = "_r7-f";
export var solidPink = "_r7-e";
export var solidRed = "_r7-9";
export var solidYellow = "_r7-a";
export var success = "_r7-4";